import { render, staticRenderFns } from "./Bando31Fase5.vue?vue&type=template&id=ce02aec2&scoped=true"
import script from "./Bando31Fase5.vue?vue&type=script&lang=js"
export * from "./Bando31Fase5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce02aec2",
  null
  
)

export default component.exports